import { gql } from '@apollo/client';

export default gql`
  query refundProposal($bookingReference: String!) {
    refundProposal(bookingReference: $bookingReference, method: VOUCHER, hotel: true) {
      value {
        amount
      }
      breakdown {
        hotel {
          amount
        }
        hotelMargin {
          amount
        }
      }
    }
  }
`;
